import { fetchUtils, GET_MANY_REFERENCE } from "react-admin";

const initResultsProvider = (
  apiUrl,
  httpClient = fetchUtils.fetchJson,
  defaultCrudHandler,
  convertDataRequestToHTTP
) => {
  return (type, resource, params) => {
    switch (type) {
      case GET_MANY_REFERENCE:
        const queryParams =
          params?.target === "teamId"
            ? `projectIds=${params.filter.projectId}&teamId=${params.id}`
            : `projectIds=${params.id}`;
        return httpClient(
          `${apiUrl}/results?includeDeleted=true&${queryParams}`
        ).then((response) => ({
          data: response.json.content,
          total: parseInt(response.json.totalElements, 10),
        }));

      default:
        return defaultCrudHandler(type, resource, params);
    }
  };
};

export default initResultsProvider;
